<p-tabs value="0">
    <p-tablist>
        <p-tab value="0">Impersonate</p-tab>
    
    </p-tablist>
    <p-tabpanels>
        <p-tabpanel value="0">
   
            <!-- container --> 
            <app-impersonate></app-impersonate>
            
        </p-tabpanel>

    </p-tabpanels>
</p-tabs>